<template>

    <div>
        <div id="slideOutMenu" class="offcanvas offcanvas-start bg-gray-100 w-64" tabindex="-1"
              aria-labelledby="offcanvasExampleLabel">
            <div class="offcanvas-header text-slate-600">
                <button type="button" class="btn-close" data-bs-dismiss="offcanvas" aria-label="Close" @click="onClose">
                    <i class="far fa-times fa-lg"></i>
                </button>
            </div>
            <div class="offcanvas-body">

                <nav class="mx-1">
                    <div class="text-slate-600 font-bold mb-3 p-2 bg-gray-200 rounded">
                        <a href="javascript:void(0)" @click="onNavClick('home')">
                            <i class="far fa-home-lg-alt fa-lg mr-3"></i> Home
                        </a>
                    </div>

                    <div class="text-slate-600 font-bold my-3 p-2 rounded bg-gray-200 rounded">
                        <a href="javascript:void(0)" @click="onNavClick('typography')">
                            <i class="far fa-font fa-lg mr-3"></i> Typography
                        </a>
                    </div>

                    <div class="text-slate-600 font-bold my-3 p-2 rounded bg-gray-200 rounded">
                        <a href="javascript:void(0)" @click="onNavClick('colors')">
                            <i class="far fa-palette fa-lg mr-3"></i> Colors
                        </a>
                    </div>
                </nav>

            </div>
        </div>
    </div>

</template>

<script>
export default {
    name: 'SlideOutMenu',
    props: ['viewModel', 'prop2'],
    data() {
        return {
            model: webase.model,
            currentOffCanvasMenu: null,
            offCanvasElement: null,
        }
    },
    mounted() {
        console.log('SlideOutMenu')
        this.offCanvasElement = document.getElementById('slideOutMenu')
        this.currentOffCanvasMenu = new bootstrap.Offcanvas(this.offCanvasElement)
        this.offCanvasElement.addEventListener('hidden.bs.offcanvas', this.onClose)
        this.currentOffCanvasMenu.show()
    },
    methods: {
        onClose() {
            this.viewModel.showMenu = false
        },
        onNavClick(route) {
            this.$router.push({name: route})
            this.onClose()
        }
    }
}
</script>
